module.exports = __webpack_public_path__ + "static/social-small-7e78ee9d27fb6f2963ee07d3e6750639.jpg";